export default __webpack_public_path__ + "static/media/9.cc9aac5e.png";